<template>
  <el-dialog
    :visible.sync="visible"
    :title="dialogTitle"
    append-to-body
    :close-on-click-modal="false"
    width="500px"
    class="dialog"
  >
    <div class="text-danger">
      注：请检查投标单位保证金缴纳情况，未缴纳需退回文件
    </div>
    <el-form ref="form" :model="form" :rules="formRules" label-suffix="：">
      <el-form-item label="文件解密时间" prop="decryptMin">
        <el-input-number
          v-model="form.decryptMin"
          controls-position="right"
          :min="0"
          :max="9999"
        />
        分钟
      </el-form-item>
    </el-form>
    <kpb-open-control-price-form
      v-if="isQuoteFile"
      ref="controlPriceForm"
      :project-id="projectId"
      :offer-unit="offerUnit"
    />
    <template v-slot:footer>
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary" @click="onConfirm">开启解密</el-button>
    </template>
  </el-dialog>
</template>

<script>
import KpbOpenControlPriceForm from '@/components/kpb/open/KpbOpenControlPriceForm.vue'
import { startBidOpenDecryptApi } from '@/api/hall/bid-open-hall'
import { bidFileTypeDict } from '@/dictionary/project/kpb-project'
import { requiredRule } from '@/utils/form-validate'
import { startQuoteDecryptApi } from '@/api/hall/quote-open'

/**
 * 解密时间限制
 */
export default {
  name: 'DecryptTimeLimit',

  components: { KpbOpenControlPriceForm },

  props: {
    projectId: {
      type: [String, Number],
      default: 0
    },

    // 报价单位,根据项目的
    offerUnit: {
      type: String,
      default: ''
    },

    bidFileType: {
      type: Number,
      default: bidFileTypeDict.BUSINESS.value
    }
  },

  data() {
    return {
      visible: false,

      form: {
        decryptMin: undefined
      },
      formRules: {
        decryptMin: [
          requiredRule('请输入文件解密时间，且不允许输入小于10的正整数'),
          {
            pattern: /^[1-9]\d+$/,
            message: '不允许输入小于10的正整数',
            trigger: ['blur', 'change']
          }
        ]
      },

      // 控制价表单
      controlForm: {},
      controlFormRules: []
    }
  },

  computed: {
    isQuoteFile() {
      return this.bidFileType === bidFileTypeDict.QUOTATION.value
    },

    dialogTitle() {
      if (this.isQuoteFile) {
        return '开启第二信封解密'
      }
      return '开启文件解密'
    }
  },

  methods: {
    onCancel() {
      this.visible = false
    },

    onConfirm() {
      this.$refs.form.validate(valid => {
        if (!valid) return

        const startMap = {
          [bidFileTypeDict.BUSINESS.value]: this.startBidOpen,
          [bidFileTypeDict.QUOTATION.value]: this.startQuoteOpen
        }
        startMap[this.bidFileType]()
      })
    },

    startBidOpen() {
      startBidOpenDecryptApi(this.projectId, this.form)
        .then(res => {
          this.$message.success('已开启商务文件解密')
          this.$emit('afterStart')
          this.visible = false
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    startQuoteOpen() {
      // 开启报价文件解密前，需要先设置控制价
      this.$refs.controlPriceForm.submitForm().then(() => {
        startQuoteDecryptApi(this.projectId, this.form)
          .then(res => {
            this.$message.success('已开启商务文件解密')
            this.$emit('afterStart')
            this.visible = false
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
          })
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
